import type { Theme } from '@emotion/react';

import { StyledSkeleton, StyledSkeletonLine } from './skeleton.styled';

export type SkeletonRadius = keyof Theme['radius'];

export interface SkeletonProps {
  /** @default '100%' */
  width?: number | string;
  /** @default 14 */
  height?: number | string;
  /** @default 6 */
  radius?: SkeletonRadius;
  /** Reserves height from the width instead of `height`, e.g. `'280 / 156'`. */
  aspectRatio?: string;
  /** Centers the bar inside a box of this height so it occupies a full text line. */
  lineHeight?: number | string;
  className?: string;
}

export const Skeleton = ({
  width = '100%',
  height = 14,
  radius = 6,
  aspectRatio,
  lineHeight,
  className,
}: SkeletonProps) => {
  const bar = (
    <StyledSkeleton
      $width={width}
      $height={height}
      $radius={radius}
      $aspectRatio={aspectRatio}
      aria-hidden="true"
      className={lineHeight === undefined ? className : undefined}
    />
  );

  if (lineHeight === undefined) return bar;

  return (
    <StyledSkeletonLine $lineHeight={lineHeight} aria-hidden="true" className={className}>
      {bar}
    </StyledSkeletonLine>
  );
};
